import { getConversations } from '../../shared/websockets/chat/chat'

export const getConversationsAsync = async ({
  ack,
  first = 20,
  after,
  setLoading = () => {},
  archived,
  onlySpyChats,
}) => {
  setLoading(true)
  try {
    await getConversations({
      ack,
      first,
      after,
      archived,
      onlySpyChats,
    })
    setLoading(false)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    setLoading(false)
  }
}



// WEBPACK FOOTER //
// ./src/Module/WS/websockets.js